module.exports = __webpack_public_path__ + "static/media/warehouse.301b36c0.svg";